import { render, staticRenderFns } from "./dyh-createtemp.vue?vue&type=template&id=1b961782&scoped=true&"
import script from "./dyh-createtemp.vue?vue&type=script&lang=js&"
export * from "./dyh-createtemp.vue?vue&type=script&lang=js&"
import style0 from "./dyh-createtemp.vue?vue&type=style&index=0&id=1b961782&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b961782",
  null
  
)

export default component.exports